import React, { ReactNode } from "react";
import { Navigate } from "react-router-dom";

type Props = { children: ReactNode };

const ProtectedRoute: React.FC<Props> = ({ children }) => {
  const token = sessionStorage.getItem("access_token");

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
